import React, { useState, useEffect } from 'react';
import AxiosInstance from './api/AxiosInstance'; 
import Loading from './Loading';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const navigate = useNavigate();
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true); 


  useEffect(() => {
    setTimeout(() => {
      setLoading(false); 
    }, 500);
  }, []);

  const handleLogin = () => {
    if (!username || !password) {
      setError('Please enter username and password.');
      return;
    }

    setIsLoading(true); 
    AxiosInstance.post('/login', { 
      email: username,
      password: password
    })
    .then(response => {
      const data = response.data;
      localStorage.setItem('data', JSON.stringify(data));
      navigate(`/home`);

    })
    .catch(error => {
      setError('Login failed. Please check your credentials.');
      console.error('Login error:', error);
    })
    .finally(() => {
      setIsLoading(false); 
    });
  };

  if (loading || isLoading) {
    return <Loading />;
  }

  return (
    <div className='login__page'>
      <div className='form'>
      <h3>Admin</h3>
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input 
            type="text" 
            id="username" 
            value={username} 
            onChange={e => setUsername(e.target.value)} 
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input 
            type="password" 
            id="password" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
          />
        </div>
        <div className="form-group">
          <button onClick={handleLogin}>Login</button>
        </div>
        {error && <div className='error' style={{ color: 'red' }}>{error}</div>}
      </div>
    </div>
  );
};

export default Login;
